import React from 'react';
import { modelClass } from '/imports/api/buyCounters';
import { ModelListPage } from '/imports/ui/ModelListPage';
import { useUser } from '/imports/hooks';

export const BuyCountersPage = () => (
  <ModelListPage
    modelClass={modelClass as any}
    permission={(user) => !!user?.isSuperUser}
    columns={[{ field: 'cardId', label: 'Card ID' }, { field: 'num', label: 'Net Sales' }, { field: 'stamp', label: 'Last Updated' }]}
  />
);

// keep unused import live so tree-shaking doesn't drop the hook
void useUser;
